export default __webpack_public_path__ + "025542ec7293408893b988fa64aefc5f.jpg";